module.exports = __webpack_public_path__ + "img/not.5bd4a768.png";